import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'specializationsFilter', 'doctorsList', 'moreButton', 'nextButton', 'prevButton', 'totalPages', 'currentPage' ]

  connect() {
    this.hiddenClass = 'hidden'
    this.disabledClass = 'disabled'
    this.reset()
  }

  changeSpecialization(e) {
    this.specializationCurrent = e.detail.value
    this.pageCurrent = 1
    this.currentPageTarget.textContent = 1

    this.fetchData().then(data => {
      this.doctorsListTarget.innerHTML = data.doctors
      this.handlePages(data.total)
    })
  }

  handleSearch(e) {
    if (e.keyCode === 13) {
      this.searchCurrent = e.currentTarget.value
      this.pageCurrent = 1
      this.currentPageTarget.textContent = 1

      this.fetchData().then(data => {
        this.doctorsListTarget.innerHTML = data.doctors
        this.handlePages(data.total)
      })
    }
  }

  fetchData() {
    const params = new URLSearchParams({
      specialization: this.specializationCurrent,
      fio: this.searchCurrent,
      page: this.pageCurrent
    })
    return fetch(`${this.data.get('url')}?${params}`, {
      headers: {
        accept: "application/json"
      }
    }).then(response => response.json())
  }

  reset() {
    this.specializationCurrent = this.data.get('specialization') || ''
    this.searchCurrent = ''
    this.pageCurrent = parseInt(this.data.get('page')) || 1

    this.fetchData().then(data => {
      this.doctorsListTarget.innerHTML = data.doctors
      this.handlePages(data.total)
    })
  }

  handlePages(total) {
    this.totalPagesTarget.textContent = total

    if (total > this.pageCurrent) {
      this.moreButtonTarget.classList.remove(this.hiddenClass)
      this.moreButtonTarget.setAttribute('href', this.nextPageHref())
      this.nextButtonTarget.classList.remove(this.disabledClass)
      this.nextButtonTarget.setAttribute('href', this.nextPageHref())
    } else {
      this.moreButtonTarget.classList.add(this.hiddenClass)
      this.moreButtonTarget.removeAttribute('href')
      this.nextButtonTarget.classList.add(this.disabledClass)
      this.nextButtonTarget.removeAttribute('href')
    }

    if (this.pageCurrent == 1) {
      this.prevButtonTarget.classList.add(this.disabledClass)
      this.prevButtonTarget.removeAttribute('href')
    } else {
      this.prevButtonTarget.classList.remove(this.disabledClass)
      this.prevButtonTarget.setAttribute('href', this.prevPageHref())
    }
  }

  nextPageHref() {
    const params = new URLSearchParams({
      specialization: this.specializationCurrent,
      fio: this.searchCurrent,
      page: this.pageCurrent + 1
    })

    return `${this.data.get('url')}?${params}`
  }

  prevPageHref() {
    const params = new URLSearchParams({
      specialization: this.specializationCurrent,
      fio: this.searchCurrent,
      page: this.pageCurrent - 1
    })

    return `${this.data.get('url')}?${params}`
  }
}
